import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ListsSandbox } from '../../../../core/lists/lists.sandbox';
import { ConfigService } from '../../../../core/service/config.service';

@Component({
  selector: 'app-controls-variant',
  templateUrl: './controls-variant.component.html',
  styleUrls: ['./controls-variant.component.scss']
})
export class ControlsVariantComponent implements OnInit {
  @Input() variantDetails: any;
  @Input() variantList: any;
  @Input() selectedVariant: any;
  @Output() optionAmount = new EventEmitter<any>();
  @Output() selectedOption = new EventEmitter<any>();
  @Output() changeVariants = new EventEmitter<any>();
  @Output() selectedOptionIds = new EventEmitter<any>();

  // pushed option value id in this array(unique id)
  public selectedOptions: any = [];
  public selectedOptionsName: any = [];

  //  public selectedVariant: any = {};

  // related product data
  public relatedProducts: Array<any>;
  public radioValue: any = 'jh';
  public totalPrice: number;
  public removeData = [];
  public removePrefix = [];
  private previousData = [];
  private previousPrefix = [];
  private temptotalPrice: number;
  // available options
  public optionNameSelected: any = [];
  public cartOptionValueArray: any = [];
  public optionNames: any = [];
  public optionValueArray: any = [];
  public previousValueRadio = '';
  public previousValueDropdown = [];
  public oneTimePush = 'enter';
  public oneTimePushValue = 'enter';
  public deleteArray = false;
  public modeSelect = [];
  public totalProductPrice: number;
  public productPriceTag: number;
  public previousPriceTag: number;
  public tempPriceRefer: number;
  public templateHidden: number;
  CurrentPage: 0;
  public imagePath: any;
  public imageUrls:any
  constructor(public productDetail: ListsSandbox, private configService: ConfigService,
  ) { }

  ngOnInit() {
    this.totalPrice = 0;
    this.temptotalPrice = 0;
    this.imagePath = this.configService.getImageUrl();
console.log('-----variemt',this.variantList)
this.imageUrls = this.configService.getImageUrl();
    // if (this.variantDetails && this.variantDetails.length > 0) {
    //   this.variantDetails.forEach(element => {
    //     if (!this.selectedVariant[element.id]) {
    //       this.selectedVariant[element.id] = '';
    //     }
    //     if (element.varientsValue && element.varientsValue.length > 0) {
    //       element.varientsValue.forEach(subElement => {
    //         if (subElement.checked) {
    //           this.selectedVariant[element.id] = subElement.id;
    //         }
    //       });
    //     }
    //   });
    //   console.log('this.selectedVariant', this.selectedVariant);
    // }
  }

  changeVariant(variant, i) {
    this.CurrentPage = i;
    console.log("varinat indexx idd",i)
    // console.log("variantId==>", variant)
    // this.selectedVariant[variantId] = valueId;
    // console.log('this.selectedVariant', this.selectedVariant);
    // const variantKeys = Object.keys(this.selectedVariant);
    // const valueIds = [];
    // if (variantKeys && variantKeys.length > 0) {
    //   variantKeys.forEach((element) => {
    //     if (this.selectedVariant[element]) {
    //       valueIds.push(this.selectedVariant[element]);
    //     }
    //   });
    // }
    // console.log('valueIds', valueIds);
    let currentOption: any = {};
    if (this.variantList && this.variantList.length > 0) {
      this.variantList.forEach(subElement => {
        let tempCount = 0;
        subElement.productVarientOption.forEach(data => {
          if (variant.indexOf(data) > -1) {
            tempCount += 1;
          }
        });
        if (tempCount === subElement.productVarientOption.length) {
          currentOption = subElement;
        }
      });
    }
    console.log('currentOption', currentOption);
    if (currentOption && Object.keys(currentOption).length > 0) {
      // this.productDetail.updateProductDetails({
      //   skuId: currentOption.skuId,
      //   skuName: currentOption.skuName,
      //   price: currentOption.price,
      //   selectedVariant: this.selectedVariant,
      // });
      this.changeVariants.emit({
        skuId: currentOption.skuId,
        skuName: currentOption.skuName,
        price: currentOption.price,
        outOfStockThreshold: currentOption.outOfStockThreshold,
        maxQuantityAllowedCart: currentOption.maxQuantityAllowedCart,
        minQuantityAllowedCart: currentOption.minQuantityAllowedCart,
        notifyMinQuantity: currentOption.notifyMinQuantity,
        enableBackOrders: currentOption.enableBackOrders,
        stockStatus: currentOption.stockStatus,
        pricerefer: currentOption.pricerefer,
        flag: currentOption.flag,
        selectedVariant: this.selectedVariant,
        optionImage: currentOption.optionImage,
        varientName: currentOption.varientName,
        varientId: currentOption.id,
        isAvailable: true,
      });
    } else {

      this.changeVariants.emit({
        skuId: 0,
        skuName: '',
        price: '',
        outOfStockThreshold: '',
        maxQuantityAllowedCart: '',
        minQuantityAllowedCart: '',
        notifyMinQuantity: '',
        enableBackOrders: '',
        stockStatus: '',
        pricerefer: '',
        flag: '',
        selectedVariant: this.selectedVariant,
        optionImage: '',
        varientName: '',
        varientId: '',
        isAvailable: false,
      });

    }
  }

  compare(arr1, arr2) {

    // tslint:disable-next-line:curly
    if (!arr1 || !arr2) return;

    let result;

    arr1.forEach((e1, i) => arr2.forEach(e2 => {

      if (e1.length > 1 && e2.length) {
        result = this.compare(e1, e2);
      } else if (e1 !== e2) {
        result = false;
      } else {
        result = true;
      }
    })
    );
    return result;
  }
}
